<div class="modal-content">
  <!-- Modal Header -->
  <div class="modal-header">
    <div class="modal-title-container">
      <h4 class="modal-title">
        Stats for Board Asset Tag
        <span class="badge bg-primary ms-2">{{assetTag}}</span>
      </h4>
      <p class="game-info mb-0">
        {{(boardStats[0]?.board?.installedGamePackage?.name || 'Unknown Game')}} - 
        {{(boardStats[0]?.board?.installedGamePackage?.version || 'Unknown Version')}}
        <span class="ms-2 badge" [ngClass]="boardStats[0]?.board?.fusionConnect ? 'bg-success' : 'bg-secondary'">
          {{boardStats[0]?.board?.fusionConnect ? 'Fusion Connect' : 'Offline'}}
        </span>
      </p>
    </div>
    <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
  </div>

  <!-- Modal Body -->
  <div class="modal-body p-0">
    <div class="table-container">
      <!-- Summary Cards for Mobile -->
      <div class="summary-cards d-md-none">
        <div class="summary-card">
          <div class="summary-label">Cash In</div>
          <div class="summary-value">${{summary?.cashInDiff.toFixed(2)}}</div>
        </div>
        <div class="summary-card">
          <div class="summary-label">Cash Out</div>
          <div class="summary-value">${{summary?.cashOutDiff.toFixed(2)}}</div>
        </div>
        <div class="summary-card">
          <div class="summary-label">Net Revenue</div>
          <div class="summary-value" [ngClass]="{'text-success': actualProfit > 0, 'text-danger': actualProfit < 0}">
            ${{actualProfit?.toFixed(2)}}
          </div>
        </div>
        <div class="summary-card">
          <div class="summary-label">Payout %</div>
          <div class="summary-value">{{avgHoldPercent | number: '1.0-1'}}%</div>
        </div>
      </div>

      <!-- Table -->
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th class="sticky-col">Date</th>
              <th>Cash In</th>
              <th>Cash Out</th>
              <th>Net</th>
              <th>Games</th>
              <th>Won</th>
              <th>Payout %</th>
              <th>Days</th>
              <th>Cash In /Day</th>
              <th>Profit /Day</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of boardStats|filter:term">
              <td class="sticky-col">{{item.timeStamp | date:'short'}}</td>
              <td>${{item.cashInDiff.toFixed(2)}}</td>
              <td>${{item.cashOutDiff.toFixed(2)}}</td>
              <td [ngClass]="{'text-success': item.profit > 0, 'text-danger': item.profit < 0}">
                ${{item.profit.toFixed(2)}}
              </td>
              <td>{{item.gamePlayedDiff}}</td>
              <td>{{item.gameWonDiff}}</td>
              <td class="text-end font-monospace">
                {{item.cashInDiff > 0 ? ((item.cashOutDiff / item.cashInDiff) * 100 | number:'1.0-1') : 'N/A'}}%
              </td>
              <td>{{item.daysSincePrevRead}}</td>
              <td>${{(item.cashInDiff / item.daysSincePrevRead).toFixed(2)}}</td>
              <td>${{(item.profit / item.daysSincePrevRead).toFixed(2)}}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td class="sticky-col"><strong>Totals</strong></td>
              <td><strong>${{summary?.cashInDiff.toFixed(2)}}</strong></td>
              <td><strong>${{summary?.cashOutDiff.toFixed(2)}}</strong></td>
              <td [ngClass]="{'text-success': actualProfit > 0, 'text-danger': actualProfit < 0}">
                <strong>${{actualProfit?.toFixed(2)}}</strong>
              </td>
              <td><strong>{{summary?.gamePlayedDiff}}</strong></td>
              <td><strong>{{summary?.gameWonDiff}}</strong></td>
              <td><strong>{{avgHoldPercent | number: '1.0-1'}}%</strong></td>
              <td><strong>{{getAverageDays() | number:'1.0-1'}}</strong></td>
              <td><strong>${{(summary?.cashInDiff / summary?.daysSincePrevRead).toFixed(2)}}</strong></td>
              <td><strong>${{(summary?.profit / summary?.daysSincePrevRead).toFixed(2)}}</strong></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>
